import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { translateLanguages } from '@app/translateLanguages';
import { ActivatedRoute, Router } from '@angular/router';
import { EventService, StreamSettings } from '@app/event/event.service';
import { Event } from '@app/graphql/generated';
import { Observable, from } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { Fonts } from '@app/shared/font-list';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  languageOptions: any;
  lang = new FormControl({ label: '', value: null });
  @Input() language = '';
  @Input() window = 1;
  @Input() event: Event;
  @Input() settings$: Observable<StreamSettings>;
  @Output() closeMenu = new EventEmitter();
  themeOptions: any = [
    { text: 'Light', value: 'light' },
    { text: 'Dark', value: 'dark' }
  ];
  filteredOptions: Observable<any[]>;
  fonts: any[];
  fontFamily: string = 'Arial';

  displayFn(item: any) {
    return item && item.label ? item.label : '';
  }

  constructor(
    // public activeModal: NgbActiveModal,
    private route: ActivatedRoute,
    public eventService: EventService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.languageOptions = translateLanguages.map(lang => ({
      label: lang.name,
      value: lang.code
    }));

    this.filteredOptions = this.lang.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.label),
        map(name => name ? this._filter(name) : this.languageOptions.slice())
      );

    this.fonts = Fonts.map(f => { return { value: f, label: f} });

    this.fontFamily = 'Arial';
  }

  private _filter(value: any): string[] {

    const filterValue = value && value.toLowerCase();

    return this.languageOptions.filter(option => option.label.toLowerCase().indexOf(filterValue) === 0);
  }

  languageValToLabel(val: any) {
    return this.languageOptions.find(item => item.value === val).label;
  }

  languageChanged($event: any) {
    this.language = $event.value.value;

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: {lang: this.language},
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  search($event: any) {
    {

      return this.languageOptions;
    }
  }

  updateFont(font: any) {
    this.fontFamily = font;
    this.eventService.setFont(font, { window: this.window });
  }

  updateFontSize(fontSize: number) {
    this.eventService.setFontSize(fontSize, { window: this.window });
  }

  updateBackground(value) {
    this.eventService.setBackground(value, { window: this.window });
  }

  updateTextColor(value) {
    this.eventService.setTextColor(value, { window: this.window });
  }

  setTheme(theme) {
    this.eventService.setTheme(theme, { window: this.window });
  }

  copyLink($event: MouseEvent) {
    event.preventDefault();
    const url = document.URL;

    this.copyTextToClipboard(url)
  }

  copyTextToClipboard(text) {
    const dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  }
}
